import moment from 'moment'
import { AnyType } from 'packages/types'

/**
 * moment时间转化为YYYY-MM-DD HH:mm格式
 *
 * @param data - 任意数据
 * @returns 字符串时间
 */
export const momentToStr = (data: AnyType, format?: string) => {
  if (moment.isMoment(data)) {
    return data.format(format || 'YYYY-MM-DD HH:mm')
  }
  return data
}

/**
 * YYYY-MM-DD HH:mm时间转化为moment格式
 *
 * @param data - 任意原始数据
 * @returns moment时间 | 原始数据
 */
export const strToMoment = (data: AnyType) => {
  const DatePattern = /^\d{1,4}(-)(1[0-2]|0?[1-9])\1(0?[1-9]|[1-2]\d|30|31)/
  if (DatePattern.test(`${data}`)) {
    return moment(data)
  }
  return data
}

/**
 * 格式化毫秒时间为字符串
 *
 * @param totalSeconds 毫秒时间
 * @returns 字符串时间
 */
export const formatMsTimeToString = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)

  if (hours > 0) {
    // 如果总时间大于一小时
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  } else {
    // 如果总时间小于一个小时
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`
  }
}

/**
 * 格式化字符串时间为毫秒，传入的字符串时间格式为 00:00:00 / 00:00
 *
 * @param timeString 00:00:00 / 00:00
 * @returns  毫秒时间
 */
export const timeStringToMs = (timeString: string): number => {
  const timeArray = timeString.split(':')
  if (timeArray.length === 2) {
    timeArray.unshift('00')
  }
  const [hours, minutes, seconds] = timeArray.map(Number)
  const totalSeconds = hours * 3600 + minutes * 60 + seconds
  return totalSeconds * 1000
}
